export const suseServiceType = 'SLES';
export const oelServiceType = 'OEL';
